import urlApi from '@/router/urlApiV2'
import urlApiV1 from '@/router/urlApi'
import Vue from 'vue'
import Toast from 'vue-toasted'

Vue.use(Toast)
export default {

  // CARREGAR LISTA DE ORDENAÇÃO
  async filterStudents () {
    let filterStudents = [
      { value: '', text: 'TODOS' },
      { value: 'regulares', text: 'COM ALUNOS REGULARES' },
      { value: 'reposicao', text: 'SEM ALUNOS REGULARES' },
    ]

    return filterStudents
  },

  // BUSCAR AULAS VIRTUAIS
  async loadData (data, callback) {
    Vue.http.post(urlApi + '/aulas/teoricas/turmas/virtuais', data)
      .then(response => {
        callback(response.data.dados)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  // BUSCAR AULAS PRESENCIAIS
  async loadDataPresenciais (data, callback) {
    let params = { schema: data.schema, type: data.type };
    if(!data.agrupamento) {
      params.filtroAlunos = data.filtroAlunos
      params.periodo = data.periodo
    } else {
      params.agrupamento = data.agrupamento
    }
    console.log(data)
    Vue.http.get(urlApi + '/aulas/teoricas/turmas/presenciais', { params })
      .then(response => {
        callback(response.data.dados)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  async loadDataClass(data, callback) {
    var url = `?autoescola=${data.schema}`;

    Vue.http.get(urlApi + '/aulas/teoricas/turmas/consultar/id/' + data.turma.id_turma_teorica + '' + url)
      .then(response => {
        console.log(response)
        callback(response.data.dados)
      })
      .catch(error => {
        callback(error)
      })
  },

  // CARREGAR DADOS DA TURMA
  async getDadosTurma (data, callback) {
    Vue.http.get(urlApi + '/turmas/consultar/schema/' + data.schema + '/id/' + data.turma)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  // BUSCAR PRESENÇAS DE TODOS OS ALUNOS DA TURMA
  async getPresencasTurma (data, callback) {
    Vue.http.get(urlApi + '/turmas/consultar/presencas/schema/' + data.schema + '/id/' + data.turma)
      .then(response => {
        callback(response.data.presencas)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  // BUSCAR PRESENÇA ALUNO/INSTRUTOR
  async getPresencas (data, callback) {
    // /id/125?schema=autoescola2000&id=17&entidade=INSTRUTOR
    // 129223
    var url = `${data.id_turma}?schema=${data.schema}&id=${data.id}&entidade=${data.entidade}`
    Vue.http.get(urlApi + '/aulas/teoricas/turmas/consultar/fotos/id/' + url)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  // BUSCAR PRESENÇA DE UM ÚNICO ALUNO DA TURMA
  async getPresencasAluno (data, callback) {
    Vue.http.post(urlApi + '/turmas/consultar/presencas', data)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  async marcarPresenca (data, callback) {
    // let url = `?schema=${data.schema}&entidade=${data.entidade}&id_turma=${data.id_turma}&id_entidade=${data.id_entidade}&entrada=${data.entrada}&intervalo=${data.intervalo}&saida=${data.saida}`
    Vue.http.post(urlApi + '/aulas/teoricas/turmas/presenca', data)
      .then(response => {
        callback(response)
      })
      .catch(error => {
        callback(error)
      })
  },

  // CANCELAR TURMA
  async cancelarTurma (data, callback) {
    Vue.http.post(urlApi + '/turmas/cancelar/' + data.turma.id_agrupamento, {'schema' : data.schema})
      .then(response => {
        callback(response)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  async enviarBiometriaVirtual (data, callback) {
    Vue.http.post(urlApiV1 + '/turmas/send/biometria/virtual', data)
      .then(response => {
        callback(response)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  // ALERT TOAST
  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    })
  },

}
